// Public metadata only. Page excerpts and the reader implementation stay on the server.
export type ReferenceStatus = 'documented' | 'read' | 'limited' | 'unavailable';
export interface ElinaReference {
  url: string;
  title: string;
  status: ReferenceStatus;
  features: string[];
  checkedAt: string;
  pages: string[];
}

export function referenceUrl(value: unknown): string | null {
  if (typeof value !== 'string' || value.length > 1200 || /[\s\\]/.test(value)) return null;
  try {
    const url = new URL(value);
    if (url.protocol !== 'https:' || url.username || url.password || url.port || url.search) return null;
    // No IP literals, local names or links to an action/account. Queries may contain access tokens.
    if (!/^(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z]{2,63}$/i.test(url.hostname)
      || /\.(?:localhost|local|internal|test|invalid|onion)$/i.test(url.hostname)
      || /(?:^|\/)(?:api|admin|login|logout|signin|signout|auth|oauth|reset|verify|unsubscribe|delete|remove|checkout|paiement)(?:\/|[._-]|$)/i.test(decodeURIComponent(url.pathname))) return null;
    url.hash = '';
    return url.href;
  } catch { return null; }
}

export function validateReferences(value: unknown): ElinaReference[] {
  if (value === undefined) return [];
  if (!Array.isArray(value) || value.length > 2) throw new Error('INVALID_REFERENCES');
  return value.map(v => {
    if (!v || typeof v !== 'object' || referenceUrl(v.url) !== v.url
      || typeof v.title !== 'string' || v.title.length > 160
      || !['documented', 'read', 'limited', 'unavailable'].includes(v.status)
      || !Array.isArray(v.features) || v.features.length > 8 || v.features.some((s: unknown) => typeof s !== 'string' || s.length > 240)
      || !Array.isArray(v.pages) || v.pages.length > 3 || v.pages.some((s: unknown) => referenceUrl(s) !== s)
      || typeof v.checkedAt !== 'string' || !/^\d{4}-\d{2}-\d{2}$/.test(v.checkedAt)) throw new Error('INVALID_REFERENCES');
    return { url: v.url, title: v.title, status: v.status, features: [...v.features], pages: [...v.pages], checkedAt: v.checkedAt };
  });
}
